import { useQuery } from 'react-query';
import { getMenuList } from '../api/getMenuList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

export const useMenuList = ({ enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.all.concat('menus'),
    () => getMenuList(),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useMenuList;
